var LoggerMiddleware, RedrawMiddleware, Reducer, applyMiddleware, createStore, ref;

ref = require('redux'), createStore = ref.createStore, applyMiddleware = ref.applyMiddleware;

Reducer = require('./Reducer');

LoggerMiddleware = require('./LoggerMiddleware');

RedrawMiddleware = require('./RedrawMiddleware');

module.exports = function(initialState) {
  return createStore(Reducer, initialState, applyMiddleware(LoggerMiddleware, RedrawMiddleware));
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3dvcmsvc3JjL3N0YXRlL1N0b3JlRmFjdG9yeS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvd29yay9zcmMvc3RhdGUvU3RvcmVGYWN0b3J5LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLE1BQW1DLE9BQUEsQ0FBUSxPQUFSLENBQW5DLEVBQUUsNkJBQUYsRUFBZTs7QUFDZixPQUFBLEdBQVUsT0FBQSxDQUFRLFdBQVI7O0FBQ1YsZ0JBQUEsR0FBbUIsT0FBQSxDQUFRLG9CQUFSOztBQUNuQixnQkFBQSxHQUFtQixPQUFBLENBQVEsb0JBQVI7O0FBRW5CLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLFNBQUMsWUFBRDtTQUNoQixXQUFBLENBQ0MsT0FERCxFQUVDLFlBRkQsRUFHQyxlQUFBLENBQWdCLGdCQUFoQixFQUFrQyxnQkFBbEMsQ0FIRDtBQURnQiJ9
